module.exports = __webpack_public_path__ + "img/M7A0285-Enhanced.57ffd8c8.jpg";